import script from "./DeMarker.vue?vue&type=script&lang=js"
export * from "./DeMarker.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__